module.exports = "https://static.wmbcdn.com/uniweb/images/845a4ab720c369fed8e4ed103d9370ee.svg";